module.exports = __webpack_public_path__ + "images/emoji/worried.db2adc5ad6e68b50dd99.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/worried.png
// module id = kC0X
// module chunks = 2